(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["sku-2"] && !Shopify.designMode) return;
  try {
    (() => {
    if (window.customElements.get('sku-2')) return;

    const POLL_MS = 250;
    const variantCache = new Map();

    const routesRoot = () =>
      (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

    const fetchVariants = (handle) => {
      if (!variantCache.has(handle)) {
        variantCache.set(
          handle,
          fetch(routesRoot() + 'products/' + encodeURIComponent(handle) + '.js', {
            headers: { Accept: 'application/json' },
          })
            .then((r) => {
              if (!r.ok) throw new Error('HTTP ' + r.status);
              return r.json();
            })
            .then((prod) => new Map(prod.variants.map((v) => [String(v.id), v.sku || ''])))
            .catch((err) => {
              variantCache.delete(handle);
              throw err;
            })
        );
      }
      return variantCache.get(handle);
    };

    class Sku2 extends HTMLElement {
      connectedCallback() {
        this.valueEl = this.querySelector('[data-sku2-value]');
        const raw = this.querySelector('script[data-sku2-data]');
        if (!this.valueEl || !raw) return;

        try {
          this.data = JSON.parse(raw.textContent);
        } catch (e) {
          return;
        }

        this.skus = new Map(Object.entries(this.data.variants || {}));
        this._id = this.dataset.initialId || null;
        this._raf = 0;
        this._schedule = this._schedule.bind(this);

        ['change', 'input', 'click'].forEach((t) =>
          document.addEventListener(t, this._schedule, true)
        );
        window.addEventListener('popstate', this._schedule);
        window.addEventListener('pageshow', this._schedule);

        this._observer = new MutationObserver(this._schedule);
        this._observer.observe(document.body, {
          subtree: true,
          childList: true,
          attributes: true,
          attributeFilter: ['value', 'checked', 'selected', 'disabled'],
        });

        this._timer = setInterval(() => {
          if (!document.hidden) this._check();
        }, POLL_MS);

        this._check();
      }

      disconnectedCallback() {
        ['change', 'input', 'click'].forEach((t) =>
          document.removeEventListener(t, this._schedule, true)
        );
        window.removeEventListener('popstate', this._schedule);
        window.removeEventListener('pageshow', this._schedule);
        if (this._observer) this._observer.disconnect();
        clearInterval(this._timer);
        cancelAnimationFrame(this._raf);
      }

      _schedule() {
        if (this._raf) return;
        this._raf = requestAnimationFrame(() => {
          this._raf = 0;
          this._check();
        });
      }

      _inputs() {
        const all = Array.from(document.querySelectorAll('[name="id"]')).filter(
          (el) => el.form && (el.form.getAttribute('action') || '').indexOf('/cart/add') !== -1
        );
        if (!all.length) return [];

        const pid = String(this.data.productId);
        const byProduct = all.filter((el) => {
          const p = el.form.querySelector('[name="product-id"]');
          return p && String(p.value) === pid;
        });
        if (byProduct.length) return byProduct;

        return this.data.main ? all : [];
      }

      _readId() {
        const inputs = this._inputs();
        for (const el of inputs) {
          if ((el.type === 'radio' || el.type === 'checkbox') && !el.checked) continue;
          if (el.value) return String(el.value);
        }
        if (this.data.main) {
          try {
            const v = new URL(window.location.href).searchParams.get('variant');
            if (v) return String(v);
          } catch (e) {}
        }
        return null;
      }

      _check() {
        if (!this.isConnected || !this.data) return;
        const id = this._readId();
        if (!id || id === this._id) return;
        this._id = id;

        const sku = this.skus.get(id);
        if (sku !== undefined) {
          this._render(sku, id);
          return;
        }

        fetchVariants(this.data.handle)
          .then((map) => {
            if (this._id !== id) return;
            this._render(map.get(id) || '', id);
          })
          .catch(() => {});
      }

      _render(sku, id) {
        const text = sku || this.dataset.emptyText || '';
        this.valueEl.textContent = text;
        this.dataset.variantId = id;
        this.hidden = !text && this.dataset.designMode !== 'true';
        this.dispatchEvent(
          new CustomEvent('sku2:change', { bubbles: true, detail: { variantId: id, sku: sku } })
        );
      }
    }

    window.customElements.define('sku-2', Sku2);
  })();
  } catch(e) { console.error(e); }
})();

})();
